<ng-template #menuOptions let-modal>
    <div class="my-modal__close" (click)="modal.dismiss('Cross click')">
        <i class="fa-solid fa-times"></i>
    </div>
    <div class="my-modal__body min-height-menu">
        @if(tabMenu === 0) {
        <ul>
            <li (click)="openWhatsapp()">
                <i class="fa-brands fa-whatsapp icon-bar"></i>
                <div class="name">Whatsapp Us</div>
            </li>
            <!-- <li *ngIf="isUserLogin == 1" [routerLink]="['/profile', referralCode]">
          <i class="fa-solid fa-user icon-bar"></i>
          <div class="name">Profile</div>
        </li> -->
            <li *ngIf="isUserLogin == 1" class="desktop" [routerLink]="['/me/list']">
                <i class="fa-solid fa-dollar-sign icon-bar"></i>
                <div class="name">Sell</div>
            </li>
            <!-- <li (click)="goTo('/advanced-settings')" *ngIf="isUserLogin == 1">
          <i class="fa-solid fa-gear icon-bar"></i>
          <div class="name">settings</div>
        </li> -->
            <!-- <li *ngIf="isUserLogin == 1" class="desktop" (click)="tabMenu = 2">
          <i class="fa-solid fa-robot icon-bar"></i>
          <div class="name">Bot</div>
        </li> -->
            <li *ngIf="isUserLogin == 1" [ngClass]="{
            desktop: true,
            'glow-notification': areThereNewMessages
          }" (click)="openProfilePopup('chat')">
                <i class="fa-solid fa-comments icon-bar"></i>
                <div class="name">chat</div>
            </li>
            <li (click)="tabMenu = 1" [ngClass]="{
            'glow-notification': surveyCount > 0
          }">
                <i class="fa-solid fa-clipboard-list icon-bar"></i>
                <div class="name">survey/Poll</div>
            </li>

             
            
            <li (click)="openAIChat()">
                <i class="fa-solid fa-robot icon-bar"></i>
                <div class="name">AI Bot</div>
            </li>
            <!-- <li (click)="goToGiveAway()">
          <i class="fa-solid fa-gift icon-bar"></i>
          <div class="name">Giveaway</div>
        </li> -->

            <li *ngIf="isUserLogin" class="desktop">
                <online-toggle-button></online-toggle-button>
                <div class="name">online</div>
            </li>
            <li *ngIf="isUserLogin" (click)="handleReport()">
                <i class="fa-solid fa-exclamation icon-bar"></i>
                <div class="name">report</div>
            </li>
        </ul>
        } @else {
        <div class="menu-2__back" (click)="tabMenu = 0"><i class="fa fa-chevron-left"></i><i
                class="fa fa-chevron-left"></i> Back</div>
        }

        <div class="menu-2__content">
            @if(tabMenu === 1) {
            <app-survey></app-survey>
            } @else if(tabMenu === 2) {
            <div class="px-3">
                <div class="under-maintenance">
                    <i class="fa-solid fa-tools icon-bar"></i>
                    <div class="name">Under Maintenance</div>
                </div>
            </div>
            }
        </div>
    </div>
</ng-template>